import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import ProductHistoryDiffView from './product-history-diff-view'
import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'

const proptypes = {
  productHistories: PropTypes.array
}

/**
 * Domain-specifc for ProductHistoryTable
 * @param {object[]} productHistories - array of product history objects
 */

const ProductHistoriesTable = ({ productHistories }) => {
  const isEmpty = productHistories.length === 0

  return (
    <Table bordered responsive className='mb-0'>
      <thead>
        <tr>
          <th>{ 'ID' }</th>
          <th>{ 'Actor' }</th>
          <th>{ 'Action' }</th>
          <th>{ 'Note' }</th>
          <th>{ 'Changes' }</th>
        </tr>
      </thead>
      <tbody>
        { isEmpty &&
          <tr>
            <td
              colSpan={ 4 }
              className='text-center'
            >
              { 'No Histories' }
            </td>
          </tr>
        }
        {
          productHistories.map((history) => (
            <tr key={ `history-${history.id}` }>
              <td>{ history.id }</td>
              <td>{ history.actor_type }</td>
              <td>{ history.action }</td>
              <td className='text-wrap'>{ history.note }</td>
              <td>
                {
                  Object.keys(history.diff).map((attribute) => (
                    <ProductHistoryDiffView
                      key={ `history-diff-${history.id}-${attribute}` }
                      diff={ history.diff }
                      attribute={ attribute }
                    />
                  ))
                }
              </td>
            </tr>
          ))
        }
      </tbody>
    </Table>
  )
}

ProductHistoriesTable.propTypes = proptypes

export default withLoader(ProductHistoriesTable, CardLoader)
